import { useI18n } from 'vue-i18n';
import { useToast } from 'vue-toast-notification';

export function useApiUtils() {
  const toast = useToast();
  const { t } = useI18n();

  /**
   * Handles API errors in a consistent way
   * @param apiCall - Async function that makes the API call
   * @param successMessage - Message to display on success
   * @returns Promise that resolves when the API call is complete
   */
  const handleApiError = async (apiCall: () => Promise<any>, successMessage: string) => {
    try {
      const result = await apiCall();
      toast.open({
        message: successMessage,
        type: 'success',
      });
      return result;
    } catch (error: any) {
      if (error.status !== 500) {
        toast.open({
          message: error.response?.data?.errors?.[0]?.detail || t('common.errors.unknown_error'),
          type: 'error',
        });
      } else {
        toast.open({
          message: t('common.errors.something_went_wrong'),
          type: 'error',
        });
      }
      throw error;
    }
  };

  return {
    handleApiError,
  };
}
